<template>
  <div class="c-tab-data">
    <div class="tab-data__wrapper">
      <div class="btns">
        <ElButton @click="downData" :loading="loading">数据导出</ElButton>
        <ElButton @click="modalColumn = true" :loading="loading">自定义列</ElButton>
      </div>
      <Viewport v-model="height">
        <el-table
          width="100%"
          ref="table"
          class="summary-el-table-styles common-el-table-styles"
          v-loading="loading"
          :data="tableData"
          :height="height - 6"
          :summary-method="summaries"
          show-summary
          border
          stripe
          @header-dragend="headerDragend"
        >
          <el-table-column
            v-for="(col, id) in tableCol"
            :key="id + col.key"
            :prop="col.key"
            :label="col.title"
            :fixed="col.fixed"
            :show-overflow-tooltip="col.overflow"
            :min-width="col.width"
            :align="col.align"
          >
            <template slot-scope="scope">
              <span v-if="col.key.indexOf('Rate') > -1">{{ scope.row[col.key] | toPercentFixed }}</span>
              <span v-else-if="col.key.indexOf('Retain') > -1">{{ scope.row[col.key] | toPercentFixed }}</span>
              <span v-else-if="col.key === 'tdate'">{{ scope.row[col.key] | datetimeToDay }}</span>
              <span v-else-if="twoDecimal.includes(col.key)">{{ scope.row[col.key] | toThousands }}</span>
              <span v-else>{{ scope.row[col.key] }}</span>
            </template>
          </el-table-column>
        </el-table>
      </Viewport>
    </div>
    <!-- 自定义列 -->
    <custom-column
      ref="tableCustomColsRef"
      v-model="modalColumn"
      name="detailDataCustomColumn"
      :data="rawTableCols"
      :subTitle="['', '报表数据', '留存数据']"
      @on-select="onTableColsChange"
    />
  </div>
</template>
<script>
import mixinTable from '../../mixin_table'
import columns from '../../../data/tabdata_columns'
import { isArray, isEmpty } from '@/common/js/utils'
import { toThousands, toPercentFixed } from '@/common/js/filters'
import { getPlanDayDetail } from '@/api/ptom.data.model'
import { HOST_API } from '@/api/config'
import CustomColumn from '@/components/converter/custom-column2.vue'
const twoDecimal = [
  'createRoleCost',
  'throusandProfitPvCost',
  'newPayCost',
  'amount',
  'newRolePayCntCost',
  'paperUseAmount',
  'pv',
  'clickNum',
  'downNum',
  'newUserNum',
  'createRoleNum',
  'newRoleNum',
  'newDeviceMoney',
  'newRoleMoney'
]
export default {
  name: 'TabData',
  mixins: [mixinTable],
  components: { CustomColumn },
  props: {
    productId: {
      type: Number
    },
    chlUserId: {
      type: Number
    },
    sourceId: {
      type: Number
    },
    detailTime: {
      type: Array
    }
  },
  data() {
    const accessAuth = this.$store.state.accessAuth
    const cols = columns.filter((col) => !col.auth || accessAuth.includes(col.auth))
    return {
      height: 330,
      loading: false,
      twoDecimal,
      modalColumn: null,
      tableColumns: cols,
      rawTableCols: JSON.parse(JSON.stringify(cols)),
      tableData: [],
      sumdata: null
    }
  },
  computed: {
    tableCol() {
      return this.tableColumns.filter((ret) => ret.checked)
    }
  },
  methods: {
    downData() {
      const [begin, end] = this.detailTime || []
      const url = `${HOST_API}/api/ptom/planDataDetail/exportDayDetail?`

      const querystring = new URLSearchParams()
      querystring.append('sessionid', this.$store.state.token)
      querystring.append('gameId', this.productId)
      querystring.append('chlId', this.chlUserId)
      querystring.append('sourceId', this.sourceId)
      querystring.append('beginTime', begin)
      querystring.append('endTime', end)

      window.open(url + querystring.toString())
    },
    getData() {
      const [beginTime, endTime] = this.detailTime || []
      const params = { gameId: this.productId, chlId: this.chlUserId, sourceId: this.sourceId, beginTime, endTime }
      this.loading = true
      getPlanDayDetail(params)
        .then((data) => {
          if (typeof data !== 'symbol') {
            this.loading = false
            if (!data) return
            const { rows, sumdata } = data
            if (isArray(rows) && sumdata) {
              this.sumdata = sumdata
              this.tableData = rows
            } else {
              this.tableData = []
            }
          }

          this.$nextTick(() => {
            this.$refs.table && this.$refs.table.doLayout()
          })
        })
        .catch((e) => {
          this.loading = false
          this.tableData = []
          this.total = 0
        })
    },
    summaries(param) {
      const { columns } = param
      const data = JSON.parse(JSON.stringify(this.sumdata))
      const sums = []

      if (!data) return sums
      columns.forEach((column, index) => {
        const prop = column.property
        const val = prop && parseFloat(data[prop])
        if (index === 0) {
          sums[index] = '合计'
          return
        }
        if (isEmpty(val)) sums[index] = ''
        else if (twoDecimal.includes(prop)) sums[index] = toThousands(val)
        else if (prop.indexOf('Rate') > -1) sums[index] = toPercentFixed(val)
        else if (prop.indexOf('Retain') > -1) sums[index] = toPercentFixed(val)
        else sums[index] = val
      })
      return sums
    },
    headerDragend(newWidth, oldWidth, column) {
      this.$refs.tableCustomColsRef.updateTableColWidth(newWidth, column)
    },
    onTableColsChange(cols) {
      this.tableColumns = cols
      this.modalColumn = false
    }
  },
  watch: {
    detailTime() {
      this.pageIndex = 1
      this.getData()
    }
  },

  created() {
    this.getData()
  }
}
</script>
<style lang="scss" scoped>
.c-tab-data {
  height: 100%;

  .btns {
    text-align: right;
    padding: 5px 0;
  }
}
</style>
